"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var action_1 = require("./action");

var connect_1 = require("./connect");

var store_1 = require("./store");

exports.createModel = function () {
  var plugins = [];
  var model = {
    createStore: function createStore(config) {
      return store_1.createStore(config, plugins);
    },
    action: action_1.action,
    connect: connect_1.connect,
    "with": function _with(p) {
      plugins.push(p);
      return model;
    },
    ctx: {}
  };
  return model;
};